import { PortfolioTitle, PortFolioWapper } from "./style";
import {
  ArrowForwardNormal,
  Portfolio1,
  Portfolio2,
  Portfolio3
} from "../../shared/icons";
import { useNavigate } from "react-router-dom";

const PortFolioSection = () => {
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 768;
  return (
    <PortFolioWapper>
      <PortfolioTitle>
        <h5>
        What we stand for <img src={ArrowForwardNormal} alt="arrow forward" />
        </h5>
        {!isMobile && <h5>About VYGA</h5>}
      </PortfolioTitle>
      <ul>
        <li>
          <img src={Portfolio1} alt="arrow forward" />
          <h3>Leveraging AI</h3>
          <p>
            When topical expertise in sustainability research and governance
            meets technological advancements. VYGA© harnesses the power of AI to
            process data and insights of diverse sources and stakeholders to
            elevate decision-making.
          </p>
        </li>
        <li>
          <img src={Portfolio2} alt="arrow forward" />
          <h3>Top-tier partners</h3>
          <p>
            We work with a curated group of partners that provide us with
            exclusive access to advanced resources and global networks. Our
            first product, the AI Cross-Chain Search, was developed with the
            support of The Hashgraph Association.
          </p>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate("/roadmap");
            }}
          >
            Check our Roadmap
            <img className="svg-hover" src={ArrowForwardNormal} alt="arrow forward" />
          </a>
        </li>
        <li>
          <img src={Portfolio3} alt="arrow forward" />
          <h3>Impactful diligence</h3>
          <p>
            VYGA © is focused on delivering real-world results. With our vast network and local initiatives, we create and support productive, measurable change that resonates across markets, industries and populations worldwide.
          </p>
          <a href="mailto:contact@vyga.co">
            Contact Now <img className="svg-hover" src={ArrowForwardNormal} alt="arrow forward" />
          </a>
        </li>
      </ul>
    </PortFolioWapper>
  );
};

export default PortFolioSection;
